import { createFileRoute, Outlet } from "@tanstack/react-router";
import { requireSuperAdmin } from "../../../lib/auth/route-protection";

export const Route = createFileRoute("/system/certifications/$moduleId")({
  beforeLoad: requireSuperAdmin(),
  component: () => <Outlet />,
});
